<template>
  <div>
    <v-container class="pt-3 pb-0 px-6">

      <!-- Floating Button -->
      <floating-button @click="dialog = true" save :disabled="!valid2" v-if="authUser && !isClient"/>

      <!-- Confirmation -->
      <confirmation
        v-model="dialog"
        title="Generar informe"
        text="Desea generar el informe"
        textButton="Generar"
        colorButton="primary"
        @close="dialog = false"
        @confirm="save()"
      >
        <br>
        Este proceso puede llevar varios minutos.
        <br>
        Una vez listo el informe se actualizará el estado de forma automática.
      </confirmation>

      <!-- Page Header -->
      <page-header
        :title="title + ' Informe'"
        icon="mdi-file-document-edit"
        divider="-"
        :breadcrumbs="breadcrumbs.items"
        refresh
        v-on:refresh="getOrder()"
      ></page-header>

      <!-- Loading Bar -->
      <v-progress-linear
        indeterminate
        v-if="isLoadingData"
      ></v-progress-linear>

      <v-stepper v-model="step" touchless alt-labels class="pa-0 elevation-0" v-if="authUser">

        <!-- Steps -->
        <v-stepper-header class="flat-stepper" v-if="!isClient">
          <v-stepper-step :step="1">Informe</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :step="2">Imágenes</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :step="3">Vista Previa</v-stepper-step>
        </v-stepper-header>

        <!-- Buttons -->
        <v-container class="py-0" v-if="!isClient">
          <v-row>
            <v-col cols="6">
              <v-btn
                v-if="isNew ? window > 1 : step > 1"
                small
                color="primary"
                @click="stepBack()"
              >Anterior</v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn
                v-if="step < 3"
                small
                color="primary"
                :disabled="window === 1 && !valid1 && !item.interventions.length || window === 2 && !valid2"
                @click="stepFoward()"
              >Siguiente</v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!-- Content -->
        <v-stepper-items>

          <v-stepper-content :step="1" class="pt-0" v-if="!isClient">
            <v-window v-model="window">

              <!-- Intervention -->
              <v-window-item :value="1">

                <!-- Selects -->
                <v-form ref="form1" lazy-validation v-model="valid1">
                  <v-row>
                    <!-- Work Type -->
                    <v-col cols="3">
                      <v-select
                        label="Tipo de trabajo"
                        v-model="item.work_type_id"
                        :items="workTypes"
                        :rules="rules"
                        required
                        outlined
                        @change="getWorkOrders()"
                        :key="component"
                      ></v-select>
                    </v-col>

                    <!-- Work Order -->
                    <v-col cols="3">
                      <v-select
                        label="Orden de trabajo"
                        v-model="item.work_order_id"
                        :items="workOrders"
                        item-text="code"
                        item-value="id"
                        :disabled="!item.work_type_id || loadingWorkOrders"
                        :rules="rules"
                        required
                        outlined
                        :loading="loadingWorkOrders"
                        @change="getWindFarms()"
                        :key="component"
                      ></v-select>
                    </v-col>

                    <!-- Wind Farm -->
                    <v-col cols="3">
                      <v-select
                        label="Parque"
                        v-model="item.wind_farm_id"
                        :items="windFarms"
                        item-text="name"
                        item-value="id"
                        :disabled="!item.work_order_id || loadingWindFarms"
                        :rules="rules"
                        required
                        outlined
                        :loading="loadingWindFarms"
                        @change="getWindTurbines()"
                        :key="component"
                      ></v-select>
                    </v-col>

                    <!-- AG -->
                    <v-col cols="3">
                      <v-select
                        label="AG"
                        v-model="item.wind_turbine"
                        :items="windTurbines"
                        item-text="wind_turbine"
                        item-value="wind_turbine"
                        :disabled="!item.wind_farm_id || loadingWindTurbines"
                        :rules="rules"
                        required
                        outlined
                        :loading="loadingWindTurbines"
                        @change="getInterventions()"
                        :key="component"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>

                  <!-- Interventions -->
                  <v-row>
                    <v-col cols="12" :class="{'py-0': !item.wind_turbine}">
                      <v-expand-transition>
                        <v-row align="center" justify="space-around" v-if="item.wind_turbine && !item.interventions.length">
                          <v-col cols="12" class="py-0">
                            <v-alert dense text type="info">
                              Debes seleccionar al menos una intervención
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-expand-transition>
                    </v-col>

                    <v-col cols="12" :class="{'py-0': !item.wind_turbine}">
                      <v-expand-transition>
                        <intervention-review
                          v-if="item.wind_turbine"
                          :reportHeaders="headers"
                          :reportItems="interventions"
                          showSelect
                          hideFilters
                          flat
                          @selected="interventionSelected($event)"
                        />
                      </v-expand-transition>
                    </v-col>
                  </v-row>

              </v-window-item>

              <!-- Data -->
              <v-window-item :value="2">

                <!-- Intervention -->
                <v-row>
                  <v-col cols="12">
                    <v-card outlined class="elevation-0">
                      <v-row v-if="window === 2">
                        <!-- Code -->
                        <v-col cols="3" class="text-center">
                          <div class="font-weight-bold">Intervenciones</div>
                          {{ item.interventions.map(element => element.id).join(', ') }}
                        </v-col>
                        <!-- Work Type -->
                        <v-col cols="3" class="text-center">
                          <div class="font-weight-bold">Tipo de trabajo</div>
                          {{ workType[item.interventions[0].work_order.work_type_id] }}
                        </v-col>
                        <!-- Wind Farm -->
                        <v-col cols="3" class="text-center">
                          <div class="font-weight-bold">Parque</div>
                          {{ item.interventions[0].wind_farm.name }}
                        </v-col>
                        <!-- Work Order Code -->
                        <v-col cols="3" class="text-center">
                          <div class="font-weight-bold">Código OT</div>
                          {{ item.interventions[0].work_order.code }}
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- Report -->
                <v-form ref="form2" lazy-validation v-model="valid2">
                  <v-row>
                    <!-- Report Type -->
                    <v-col cols="4">
                      <v-select
                        label="Tipo de informe"
                        v-model="item.report_type"
                        :items="reportTypes"
                        :rules="rules"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <!-- Language -->
                    <v-col cols="4">
                      <v-select
                        label="Idioma"
                        v-model="item.language"
                        :items="languages"
                        :rules="rules"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <!-- Date -->
                    <v-col cols="4">
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            label="Fecha creación"
                            v-model="item.report_date"
                            :rules="rules"
                            required
                            readonly
                            outlined
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="item.report_date" @input="menu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <!-- Descripcion -->
                    <v-col cols="12">
                      <v-text-field
                        label="Descripción"
                        v-model="item.version_description"
                        :rules="rules"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>

              </v-window-item>

            </v-window>
          </v-stepper-content>

          <v-stepper-content :step="2" class="pt-0">

            <v-row align="center">

              <v-col cols="12">
                <v-select
                  v-model="damageSelected"
                  :items="filteredDamages"
                  :item-text="text"
                  item-value="id"
                  label="Daño"
                  hint="Daño | Intervención | AG | Posición | Código del daño | Grado"
                  persistent-hint
                  outlined
                  @change="component++"
                ></v-select>
              </v-col>

            </v-row>

            <v-row align="start" justify="space-around" v-if="step === 2 && damageSelected">

              <v-col cols="3">

                <!-- Reparation -->
                <v-row no-gutters align="center" justify="space-around" v-if="damageSelected">

                  <v-col cols="8">
                    <v-subheader>Imágenes</v-subheader>
                  </v-col>

                  <v-col cols="4" class="text-right">
                    <v-btn-toggle tile borderless color="primary" v-model="grid" >
                      <v-btn icon :value="false">
                        <v-icon>mdi-view-list</v-icon>
                      </v-btn>

                      <v-btn icon :value="true">
                        <v-icon>mdi-view-grid</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>

                  <!-- Reparation -->
                  <v-col cols="12" v-if="isReparation">
                    <v-list>
                      <v-list-item-group v-model="imageType">

                        <v-list-item value="before">
                          <v-list-item-title>Antes</v-list-item-title>
                        </v-list-item>

                        <v-list-item value="repair_stage">
                          <v-list-item-title>En proceso</v-list-item-title>
                        </v-list-item>

                        <v-list-item value="after">
                          <v-list-item-title>Después</v-list-item-title>
                        </v-list-item>

                      </v-list-item-group>
                    </v-list>
                  </v-col>

                  <!-- Inspection -->
                  <v-col cols="12" v-else>
                    <v-list>
                      <v-list-item-group v-model="imageType">

                        <v-list-item value="panoramic">
                          <v-list-item-title>Panorámicas</v-list-item-title>
                        </v-list-item>

                        <v-list-item value="inspection">
                          <v-list-item-title>Daño</v-list-item-title>
                        </v-list-item>

                      </v-list-item-group>
                    </v-list>
                  </v-col>

                </v-row>

                <!-- Order -->
                <!-- <v-row align="center" justify="space-around">
                  <v-col cols="12">
                    <v-subheader>Orden</v-subheader>
                  </v-col>
                  <v-col class="text-center" :cols="gridSize" v-for="item in gridNumber" :key="item.id">
                    <v-card class="grey">
                      <v-card-text class="white--text">
                        {{ item }}
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row> -->

              </v-col>

              <v-col cols="9">
                <v-card  class="grey lighten-4" style="height: 65vh; overflow-y: scroll" :key="component">
                  <v-card-text>

                    <!-- Reparation -->
                    <v-window v-model="imageType" touchless v-if="isReparation">

                      <v-window-item value="before">
                        <edit-report-images
                          :grid="grid"
                          :damage="damageSelected"
                          :images="bladeDamagesImages"
                          :selected="item.damages[damageSelected] && item.damages[damageSelected]['before_repair_image_ids']"
                          type="before_repair_image_ids"
                          imageType="before"
                          @change="imagesChange($event)"
                        />
                      </v-window-item>

                      <v-window-item value="repair_stage">
                        <edit-report-images
                          :grid="grid"
                          :damage="damageSelected"
                          :images="bladeDamagesImages"
                          :selected="item.damages[damageSelected] && item.damages[damageSelected]['repair_stage_image_ids']"
                          type="repair_stage_image_ids"
                          imageType="repair_stage"
                          @change="imagesChange($event)"
                        />
                      </v-window-item>

                      <v-window-item value="after">
                        <edit-report-images
                          :grid="grid"
                          :damage="damageSelected"
                          :images="bladeDamagesImages"
                          :selected="item.damages[damageSelected] && item.damages[damageSelected]['after_repair_image_ids']"
                          type="after_repair_image_ids"
                          imageType="after"
                          @change="imagesChange($event)"
                        />
                      </v-window-item>

                    </v-window>

                    <!-- Inspection -->
                    <v-window v-model="imageType" touchless v-else>

                      <v-window-item value="panoramic">
                        <edit-report-images
                          :grid="grid"
                          :images="panoramicImages"
                          :selected="item && item['panoramic_image_ids']"
                          type="panoramic_image_ids"
                          imageType="panoramic"
                          @change="imagesChange($event)"
                        />
                      </v-window-item>

                      <v-window-item value="inspection">
                        <edit-report-images
                          :grid="grid"
                          :damage="damageSelected"
                          :images="bladeDamagesImages"
                          :selected="item.damages[damageSelected] && item.damages[damageSelected]['inspection_image_ids']"
                          type="inspection_image_ids"
                          imageType="inspection"
                          @change="imagesChange($event)"
                        />
                      </v-window-item>

                    </v-window>

                  </v-card-text>
                </v-card>
              </v-col>

            </v-row>

          </v-stepper-content>

          <v-stepper-content :step="3" class="pt-0" v-if="!isClient">
            <report-preview
              v-if="step === 3 && body"
              :report="item"
              :body="body"
              :isReparation="isReparation"
              :key="component"
            />
          </v-stepper-content>

        </v-stepper-items>

      </v-stepper>

    </v-container>
  </div>
</template>

<style>
.flat-stepper {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>

<script>
import FloatingButton from "@/components/FloatingButton";
import Confirmation from "@/components/Confirmation";
import PageHeader from "@/components/PageHeader";
import InterventionReview from '@/views/InterventionReview'
import EditReportImages from "@/components/report/EditReportImages";
import ReportPreview from "@/components/report/preview";
import Util from "@/util/index";
import STATES from '@/models/States'
import moment from 'moment'

export default {
  components: {
    FloatingButton,
    Confirmation,
    PageHeader,
    InterventionReview,
    EditReportImages,
    ReportPreview
  },
  data: () => ({
    component: 0,
    step: 1,
    window: 1,
    authUser: false,
    dialog: false,
    valid1: false,
    valid2: false,
    grid: false,
    menu: false,
    isLoadingFiles: false,
    isLoadingData: false,
    loadingWorkOrders: false,
    loadingWindFarms: false,
    loadingWindTurbines: false,
    rules: [v => !!v || 'Obligatorio.'],
    inspeccion: STATES.WORK_ORDER_TYPE_INSPECCION,
    reparacion: STATES.WORK_ORDER_TYPE_REPARACION,
    reportTypes: STATES.REPORT_TYPES,
    workType: STATES.WORK_ORDER_TYPE,
    workTypes: STATES.WORK_ORDER_TYPES,
    bladeDamages: [],
    isSimilarDamage: [],
    images: [],
    imageType: 'before',
    languages: STATES.REPORT_LANGUAGES,
    damageSelected: null,
    body: null,
    item: {
      damages: {},
      interventions: []
    },
    headers: [
      { text: "", value: "expand", sortable: false, align: "center" },
      { text: "Código Intervención", value: "id", align: "center" },
      { text: "Tipo de trabajo", value: "work_order.work_type", align: "center" },
      { text: "Operarios", value: "users", align: "center" },
    ],
    fileHeaders: [
      { text: "Nombre", value: "name", align: "center" },
      { text: "Acción", value: "action", sortable: false, align: "center" }
    ],
    breadcrumbs: {
      items: [
        { text: "Configuración", disabled: true },
        { text: "Informe", disabled: true }
      ]
    },
  }),
  watch: {
    window () {
      if (this.$refs.form1) this.$refs.form1.resetValidation()
      if (this.$refs.form2) this.$refs.form2.resetValidation()
    },
    step (val) {
      if (val < 3) this.body = null
    },
    isClient (val) {
      if (val) this.step = 2
    }
  },
  computed: {
    isClient () {
      return this.$store.getters['IS_CLIENT']
    },
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    isNew () {
      return !this.$route.params.id
    },
    title () {
      return this.isNew ? 'Modificar' : 'Generar'
    },
    isReparation() {
      return this.isNew
        ? this.item.work_type_id === this.reparacion
        : this.item.interventions[0].work_order.work_type_id === this.reparacion
    },
    gridNumber () {
      return this.$store.state.reports.gridNumber[this.imageType]
    },
    gridSize () {
      return this.$store.state.reports.gridSize[this.imageType]
    },
    workOrders() {
      return this.$store.state.reports.workOrders
    },
    windFarms() {
      return this.$store.state.reports.windFarms
    },
    windTurbines() {
      return this.$store.state.reports.windTurbines
    },
    interventions() {
      return this.$store.state.reports.interventions
    },
    // Damages
    bladeDamageSimilars () {
      return this.$store.state.interventions.bladeDamageSimilars.list
        .filter(element => element.damage && element.damage.wind_turbine === this.item.wind_turbine)
    },
    filteredDamages () {
      return this.bladeDamages.filter(element => !this.isSimilarDamage.includes(element.id))
    },
    bladeDamagesImages() {
      return this.images.filter(element => element.blade_damage_id === this.damageSelected && element.type === this.imageType)
    },
    panoramicImages() {
      return this.images.filter(element => element.type === 'panoramic')
    },
  },
  methods: {
    text (item) {
      const index = this.filteredDamages.indexOf(item)
      return Number(index + 1) + ' | ' + item.work_intervention_id + ' | ' + item.wind_turbine + ' | ' + item.location + ' | ' + item.blade_damage_type.name + ' | ' + item.severity
    },
    reportList () {
      this.$router.push({
        name: "report-list"
      });
    },
    errorAlert (error, altText) {
      if (error.response.status === 403 ) {
        this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
          color: "error",
          x: "center",
          y: "top",
          icon: "mdi-information",
          timeout: 0,
          showClose: true,
          closeText: "Cerrar"
        });
        this.$router.push({ name: 'home'})
      } else {
        let errorToastMessage = `Ha ocurrido un error ${altText}`
        Util.showErrorToast(this, error, errorToastMessage);
      }
    },
    stepBack() {
      this.step > 1 ? this.step-- : this.window--
    },
    stepFoward() {
      if (this.window === 1 && this.$refs.form1.validate() && this.item.interventions.length) this.getDamages()
      else if (this.$refs.form2 && this.$refs.form2.validate()) {
        if (this.step === 2) {
          this.body = this.getBody()
        }
        this.step++
      }
    },
    // Init
    init () {
      if (this.isNew) this.authUser = true
      else {
      this.loading = true

      if (this.isClient) this.step = 2
      else this.window = 2

      const body = {
        id: this.$route.params.id
      }

      this.$store.dispatch('reports/get', body)
        .then(async response => {
          const data = response.data.data
          this.item = data
          this.item.version_description = ''
          this.item.interventions = []
          this.item.report_date = moment(data.report_date).format('YYYY-MM-DD')
          await this.getInterventions(true)
          for (let i=0; i < this.interventions.length; i++) {
            const element = this.interventions[i]
            if (this.item.work_intervention_ids.includes(element.id)) this.item.interventions.push(element)
          }
          await this.getDamages()
          this.authUser = true
        })
        .catch(error => {
          if (error && error.response && error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "cargando el reporte."
            this.errorAlert(error, errorToastMessage)
          }
        })
        .finally(() => {
          this.component++
          this.loading = false
        })
      }
    },
    // Change
    interventionSelected(items) {
      console.log(`🚀 ~ file: ReportsEdit.vue ~ line 725 ~ interventionSelected ~ items`, items)
      this.isLoadingData = true
      this.item.interventions = items
      this.imageType = this.isReparation ? 'before' : 'panoramic'
      this.item.report_date =  ''
      this.item.language = ''
      this.item.report_type = ''
      this.isLoadingData = false
    },
    imagesChange(event) {
      const damage = this.damageSelected
      const type = event.type
      // const images = event.images.map(element => element.id)
      const images = event.images
      if (!this.item.damages[damage]) this.item.damages[damage] = {}
      type.includes('panoramic')
        ? this.item[type] = images
        : this.item.damages[damage][type] = images
      console.log("imagesChange -> this.item", event, this.item)
    },
    // Get
    getWorkOrders() {
      this.loadingWorkOrders = true

      this.item.work_order_id = ''
      this.item.wind_farm_id = ''
      this.item.wind_turbine = ''
      this.$refs.form1.resetValidation()

      const body = {
        work_type_id: this.item.work_type_id
      }

      this.$store.dispatch('reports/workOrders', body)
        .catch(error => {
          if (error && error.response && error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "cargando la lista de ordenes de trabajo."
            this.errorAlert(error, errorToastMessage)
          }
        })
        .finally(() => {
          this.component++
          this.loadingWorkOrders = false
        })
    },
    getWindFarms() {
      this.loadingWindFarms = true

      this.item.wind_farm_id = ''
      this.item.wind_turbine = ''
      this.$refs.form1.resetValidation()

      const body = {
        work_order_id: this.item.work_order_id
      }

      this.$store.dispatch('reports/windFarms', body)
        .catch(error => {
          if (error && error.response && error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "cargando la lista de parques."
            this.errorAlert(error, errorToastMessage)
          }
        })
        .finally(() => {
          this.component++
          this.loadingWindFarms = false
        })
    },
    getWindTurbines() {
      this.loadingWindTurbines = true

      this.item.wind_turbine = ''
      this.$refs.form1.resetValidation()

      const body = {
        work_order_id: this.item.work_order_id,
        wind_farm_id: this.item.wind_farm_id
      }

      this.$store.dispatch('reports/windTurbines', body)
        .catch(error => {
          if (error && error.response && error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "cargando la lista de aerogeneradores."
            this.errorAlert(error, errorToastMessage)
          }
        })
        .finally(() => {
          this.component++
          this.loadingWindTurbines = false
        })
    },
    async getInterventions(init) {
      if (!init) this.loading = true

      const body = {
        work_order_id: this.item.work_order_id,
        wind_farm_id: this.item.wind_farm_id,
        wind_turbine: this.item.wind_turbine,
        with: 'workOrder,windFarm,users'
      }

      await this.$store.dispatch('reports/interventions', body)
        .catch(error => {
          if (error && error.response && error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "cargando la lista de intervenciones."
            this.errorAlert(error, errorToastMessage)
          }
        })
        .finally(() => {
          this.component++
          if (!init) this.loading = false
        })
    },
    async getDamages () {
      this.loading = true
      this.bladeDamages = []
      await this.getDamageSimilars()
      for (let i=0; i < this.item.interventions.length; i++) {
        const element = this.item.interventions[i]
        const body = {
          work_intervention_id: element.id,
          work_order_id: element.work_order_id,
          wind_turbine: this.item.wind_turbine,
          with: 'bladeDamageType,windTurbineType,windTurbineBladeType,damageImages,repairStages'
        }
        await this.$store.dispatch('interventions/bladeDamages/list', body)
          .then(response => {
            const data = response.data.data
            this.bladeDamages = this.bladeDamages.concat(data)
          })
          .catch(error => {
            if (error.response.status === 403 ) {
              this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
                color: "error",
                x: "center",
                y: "top",
                icon: "mdi-information",
                timeout: 0,
                showClose: true,
                closeText: "Cerrar"
              });
              this.$router.push({ name: 'home'})
            } else {
              var errorToastMessage = "cargando la lista de daños."
              this.errorAlert(error, errorToastMessage)
            }
          })
      }
      await this.getImages()
      this.damageSelected = this.bladeDamages[0].id
      if (this.isNew) this.window++
      this.loading = false
    },
    async getDamageSimilars () {
      const body = {
        work_order_id: this.item.work_order_id,
        with: 'damage, similarDamage'
      }
      await this.$store.dispatch('interventions/bladeDamageSimilars/list', body)
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home' })
          } else {
            var errorToastMessage = "cargando la lista de daños."
            this.errorAlert(error, errorToastMessage)
          }
        })
    },
    async getImages() {
      // Panoramic
      if (!this.isReparation) {
        for (let i=0; i < this.item.interventions.length; i++) {
          const element = this.item.interventions[i]
          await this.getPanoramicImages(element.id)
        }
      }
      // Blade Damages
      if (this.isReparation) {
        for (let i=0; i < this.item.interventions.length; i++) {
          const element = this.item.interventions[i]
          await this.getRepairStageImages(element.id)
        }
      }
      for (let i=0; i < this.bladeDamages.length; i++) {
        const element = this.bladeDamages[i]
        await this.getDamagesImages(element)
      }
      // TEST

        const reparationImages = [
          { type: 'before', key: 'before_repair_image_ids'},
          { type: 'repair_stage', key: 'repair_stage_image_ids'},
          { type: 'after', key: 'after_repair_image_ids'},
        ]

        const damages = {}
        let itemDamages = []

        if (!this.isNew) itemDamages = await JSON.parse(JSON.stringify(this.item.damages))

        // Reparation
        if (this.isReparation) {
          // Damages
          for (let i=0; i < this.bladeDamages.length; i++) {
            const images = {}
            const damage = this.bladeDamages[i]

            // Similar Damage
            let isSimilarDamage = null
            for (let k=0; k < this.bladeDamageSimilars.length; k++) {
              const element = this.bladeDamageSimilars[k]
              if (element.similar_blade_damage_id === damage.id) isSimilarDamage = element.blade_damage_id
            }

            if (isSimilarDamage) {
              const exist = this.isSimilarDamage.some(element => element == damage.id)
              if (!exist) this.isSimilarDamage.push(damage.id)
            }

            // Init Value
            const id = isSimilarDamage ? isSimilarDamage : damage.id
            if (!damages[id]) damages[id] = {}

            // Images Orders
            const imagesOrder = {}
            if (!this.isNew) {
              const filtered = itemDamages.filter(element => element.blade_damage_id == id)
              const keys = Object.keys(filtered[0])
              for (let l=0; l < keys.length; l++) {
                const key = keys[l]
                const element = filtered[0][key]
                if (key !== 'blade_damage_id') {
                  const array = element.map(e => e.id)
                  imagesOrder[key] = array
                }
              }
            }

            // Images Types
            for (let n=0; n < reparationImages.length; n++) {
              const type = reparationImages[n].type
              const key = reparationImages[n].key

              const filteredImages = this.images.filter(element => {
                return this.isNew
                  ? element.type === type && element.blade_damage_id == damage.id
                  : element.type === type && imagesOrder[key].includes(element.id)
              })

              const showImages = filteredImages.map(image => {
                const obj = {
                  ...image,
                  show: true
                }
                if (!this.isNew) obj.show = imagesOrder[key].some(element => element == image.id)
                return obj
              })

              images[key] = showImages

              // Sort Images
              if (!this.isNew) {
                let sortedImages = []
                for (let m=0; m < imagesOrder[key].length; m++) {
                  const sortId = imagesOrder[key][m]
                  const filteredSortImage = showImages.filter(element => element.id == sortId)
                  if (filteredSortImage.length) sortedImages.push(filteredSortImage[0])
                }
                const filteredSort = showImages.filter(image => !imagesOrder[key].some(element => element == image.id))
                images[key] = sortedImages.concat(filteredSort)
              }

              // Assign Images
              this.isNew && damages[id][key] && damages[id][key].length
                ? damages[id][key] = damages[id][key].concat(images[key])
                : damages[id][key] = images[key]
            }
          }
        }
        // Inspection
        else {
          // Panoramic
          let imagesPanoramic = []

          let orderPanoramic = []
          if (!this.isNew) orderPanoramic = this.item['panoramic_image_ids']

          const filteredPanoramic = this.images.filter(element => element.type === 'panoramic')

          const showPanoramic = filteredPanoramic.map(element => {
            const obj = {
              ...element,
              show: true
            }
            if (!this.isNew) obj.show = orderPanoramic.includes(element.id)
            return obj
          })

          imagesPanoramic = showPanoramic

          // Sort Images
          if (!this.isNew) {
            let sortedImages = []
            for (let n=0; n < orderPanoramic.length; n++) {
              const sortId = orderPanoramic[n]
              const filtered = showPanoramic.filter(element => element.id == sortId)
              if (filtered.length) sortedImages.push(filtered[0])
            }
            const filtered = showPanoramic.filter(image => !orderPanoramic.some(element => element == image.id))
            imagesPanoramic = sortedImages.concat(filtered)
          }

          this.item['panoramic_image_ids'] = imagesPanoramic

          // Damages
          for (let i=0; i < this.bladeDamages.length; i++) {
            let images = []
            const damage = this.bladeDamages[i]

            // Similar Damage
            let isSimilarDamage = null
            for (let k=0; k < this.bladeDamageSimilars.length; k++) {
              const element = this.bladeDamageSimilars[k]
              if (element.similar_blade_damage_id === damage.id) isSimilarDamage = element.blade_damage_id
            }

            if (isSimilarDamage) {
              const exist = this.isSimilarDamage.some(element => element == damage.id)
              if (!exist) this.isSimilarDamage.push(damage.id)
            }

            // Init
            const id = isSimilarDamage ? isSimilarDamage : damage.id
            if (!damages[id]) damages[id] = {}

            // Images Orders
            let imagesOrder = []
            if (!this.isNew) {
              const filtered = itemDamages.filter(element => element.blade_damage_id == id)
              const array = filtered[0]['inspection_image_ids'].map(element => element.id)
              imagesOrder = array
            }

            const filteredImages = this.images.filter(element => {
              return this.isNew
                ? element.type === 'inspection' && element.blade_damage_id == damage.id
                : element.type === 'inspection' && imagesOrder.includes(element.id)
            })

            const showImages = filteredImages.map(image => {
              const obj = {
                ...image,
                show: true
              }
              if (!this.isNew) obj.show = imagesOrder.some(element => element == image.id)
              return obj
            })

            images = showImages

            // Sort Images
            if (!this.isNew) {
              let sortedImages = []
              for (let n=0; n < imagesOrder.length; n++) {
                const sortId = imagesOrder[n]
                const filtered = showImages.filter(element => element.id == sortId)
                if (filtered.length) sortedImages.push(filtered[0])
              }
              const filtered = showImages.filter(image => !imagesOrder.some(element => element == image.id))
              images = sortedImages.concat(filtered)
            }

            // Assign Images
            const key = 'inspection_image_ids'
            damages[id][key] && damages[id][key].length && this.isNew
              ? damages[id][key] = damages[id][key].concat(images)
              : damages[id][key] = images
          }
        }
         console.log("damages", damages)
         this.item.damages = damages
      // TEST
    },
    async getDamagesImages (params) {
      const body = {
        id: params.id,
        work_intervention_id: params.work_intervention_id,
        work_order_id: this.item.work_order_id,
        with: 'damageImages'
      }
      await this.$store.dispatch('interventions/bladeDamages/images', body)
        .then(response => {
          const data = response.data.data.damage_images
          this.images = this.images.concat(data)
          this.component++
        })
        .catch(error => {
          let altText = "cargando lista de imágenes"
          this.errorAlert(error, altText)
        })
    },
    async getRepairStageImages (id) {
      const body = {
        work_intervention_id: id,
        work_order_id: this.item.work_order_id
      }
      await this.$store.dispatch('interventions/repairStages/getInterventionFiles', body)
        .then(response => {
          const data = response.data.data.map(element => {
            const obj = {
              ...element
            }
            obj.type = 'repair_stage'
            obj.blade_damage_id = element.repair_stage.blade_damage_id
            return obj
          })
          this.images = this.images.concat(data)
          this.component++
        })
        .catch(error => {
          let altText = "cargando lista de imágenes"
          this.errorAlert(error, altText)
        })
    },
    async getPanoramicImages (id) {
      const body = {
        work_intervention_id: id
      }
      await this.$store.dispatch('interventions/bladePanoramicImages/list', body)
        .then(response => {
          const data = response.data.data.map(element => element.panoramic_images)
          let tempImages = []

          for (let i=0; i < data.length; i++) {
            const element = data[i]
            tempImages = tempImages.concat(element)
          }

          const images = tempImages.map(element => {
            const obj = {
              ...element
            }
            obj.type = 'panoramic'
            return obj
          })

          this.images = this.images.concat(images)
          this.component++
        })
        .catch(error => {
          let altText = "cargando lista de imágenes"
          this.errorAlert(error, altText)
        })
    },
    // Save
    getBody () {
      const imageTypes = [
        'before_repair_image_ids',
        'repair_stage_image_ids',
        'after_repair_image_ids',
        'inspection_image_ids'
      ]

      const body = {
        ...this.item,
        work_intervention_ids: this.item.interventions.map(element => element.id)
      }

      if (body.panoramic_image_ids) body.panoramic_image_ids = this.item.panoramic_image_ids.map(element => element.id)

      const damages = []

      for (let i=0; i < this.filteredDamages.length; i++) {
        const damage = this.filteredDamages[i]
        const obj = {
          blade_damage_id: damage.id,
          work_intervention_id: damage.work_intervention_id
        }
        for (let k=0; k < imageTypes.length; k++) {
          const type = imageTypes[k]
          const images = body.damages[damage.id]
          if (images[type] && images[type].length) {
            obj[type] = images[type].filter(element => element.show).map(element => {
              const obj = {
                id: element.id,
              }
              type === 'repair_stage_image_ids'
                ? obj.repair_stage_id = element.repair_stage_id
                : obj.blade_damage_id = element.blade_damage_id
              return obj
            })
          }
        }
        damages.push(obj)
      }

      body.damages = damages

      delete body.work_type_id
      delete body.wind_farm
      delete body.interventions



      if (!this.isNew) {
        body.id = this.$route.params.id
        delete body.language
        delete body.wind_farm_id
        delete body.wind_turbine
        delete body.work_intervention_ids
        delete body.work_order_id
      }

      console.log("getBody -> body", body)
      return body
    },
    save () {
      this.isNew ? this.create() : this.createVersion()
    },
    create () {
      if (this.$refs.form2.validate()) {
        this.dialog = false
        this.loading = true
        const body = this.getBody()
        this.$store.dispatch('reports/create', body)
          .then(() => {
            this.$toast("Informen creado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.reportList()
          })
          .catch(error => {
            var errorToastMessage = "Ha ocurrido un error creando el informe."
            Util.showErrorToast(this, error, errorToastMessage);
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    createVersion () {
      if (this.$refs.form2.validate()) {
        this.dialog = false
        this.loading = true
        const body = this.getBody()
        this.$store.dispatch('reports/createVersion', body)
          .then(() => {
            this.$toast("Informen creado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.reportList()
          })
          .catch(error => {
            var errorToastMessage = "Ha ocurrido un error creando el informe."
            Util.showErrorToast(this, error, errorToastMessage);
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  },
  created() {
    this.init()
  }
}
</script>
